
import { useEffect, useState } from "react";
import api from "../../../../../services/api";
import HeaderSession from "../../../../../utils/headerSession";
import { useDispatch, useSelector } from 'react-redux';
import Paginacao from "../../../../../utils/paginacao";
import { useNavigate, useSearchParams } from "react-router-dom";
import { isTablet } from 'react-device-detect';
import RegisterAccess from "../../../../../utils/registerAccess";
import ListaInspecoes from "../listaInspecoes";
import { temPermissao } from "../../../../../utils/permissoes";
import TabelaLoading from "../../../../../load/tabelaLoading";


export default function InspeccaoAgendadaArea() {
  const navigate = useNavigate()
  const user = useSelector(state => state.account.user);
  const [tipo, setTipo] = useState('')
  const [perPage, setPerPage] = useState(50)
  const [order, setOrder] = useState('')
  const [loading, setLoading] = useState(false);
  const [configLista, setConfigLista] = useState('')
  const dispatch = useDispatch();
  const [inspeccoes, setInspeccoes] = useState('');
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));
  const [inspectorId, setInspectorId] = useState('')
  const [provincia, setProvincia] = useState('')

  useEffect(() => {

    if (isTablet || user?.funcao === 'Inspector') {
      navigate('/admin/minhas-inspeccoes')
    }

    if ((user?.funcao === 'Inspector' || user?.funcao === 'Director Geral' || user?.funcao === 'Chefe de Departamento' || user?.funcao === 'CNP') || temPermissao(user, ['licenciamentoEstabelecimentoInspeccaoAgendada'])) {
    } else {
      dispatch({
        type: 'alert',
        payload: { alert: 'Acesso negado' },
      });
      navigate('/admin/menu')
    }

    setLoading(true)
    setInspeccoes('')
    // api.get(`/inspeccaos?status=Não Realizada`)
    api.get(`/inspeccaos?page=${page}&status=Não Realizada&perPage=${perPage}&sortBy=nome:${order}&inspectorId=${inspectorId}&provincia=${provincia}&tipoId=${tipo}`)
      .then(response => {
        // console.log(response)
        setConfigLista(response.data);
        setInspeccoes(response.data.inspeccaos);
      }).catch(err => 'console.log(err)').
      finally(() => { setLoading(false) })

  }, [page, perPage, tipo, order, navigate, user?.funcao, inspectorId, provincia, dispatch]);


  return (
    <>
      <RegisterAccess page={'area de inspeccao agendada'} />

      <HeaderSession
        title='ESTABELECIMENTOS A SEREM INSPECCIONADOS'
        actions={true}
      // handleExportExcel={() => SolicitacoesLicenciamentoExcel(estabelecimentos)}
      // handleExportPDF={() => SolicitacaoLicenciamentoPdf(estabelecimentos)}
      />

      {inspeccoes ?
        <ListaInspecoes
          inspeccoes={inspeccoes}
          inspectorId={inspectorId}
          setInspectorId={setInspectorId}
          provincia={provincia}
          setProvincia={setProvincia}
        >
          <Paginacao
            configLista={configLista}
            lista={inspeccoes}
            page={page}
            setPage={setPage}
            setPerPage={setPerPage}
            setOrder={setOrder}

          />
        </ListaInspecoes>
        :
        <TabelaLoading />
      }
    </>
  )
}
